<lgv-loading-indicator *ngIf="isLoading$ | async"></lgv-loading-indicator>

<div class="Vert-15"></div>
<div class="container edit">

    <form [formGroup]="propertyInfoForm">
        <h1>Welcome to HomeDashboard!</h1>

        <div *ngIf="selectedProperty$ | async as property">You are one step away from accessing your free homebuyer dashboard for <b>{{property.propertyInfo.address}}, {{property.propertyInfo.city}} {{property.propertyInfo.state}} {{property.propertyInfo.zip}}</b>.  Please enter the information about this property to continue.</div>

        <div class="Vert-25"></div>

        <div class="row">


            <mat-form-field appearance="outline" floatLabel="always" class="col-12">
                <mat-label>Property Type</mat-label>
                <mat-select formControlName="propertyType" required>
                    <mat-option *ngFor="let type of (propertyTypes$ | async)" [value]="type">
                        {{type.name}}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="propertyInfoForm.controls.propertyType.errors?.required">
                    Please select one option from the dropdown
                </mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" floatLabel="always" class="col-12">
                <mat-label>Listing Price</mat-label>
                <input type="number" matInput formControlName="listingPrice" required>
                <span matPrefix>$&nbsp;</span>
                <mat-error *ngIf="propertyInfoForm.controls.listingPrice.errors?.required">
                    Listing Price is required
                </mat-error>
                <mat-error *ngIf="!propertyInfoForm.controls.listingPrice.errors?.required
                                && propertyInfoForm.controls.listingPrice.invalid">
                    Value must be greater than 0
                </mat-error>
            </mat-form-field>

        </div>

        <div class="Vert-10"></div>

        <div class="row">
            <div class="col-12" align="end">
                <button mat-button class="btn btn-primary float-end" (click)="onSubmit()"
                        [disabled]="(isLoading$ | async) || !propertyInfoForm.valid">
                    Submit
                </button>

            </div>
        </div>
    </form>


</div>
<div class="Vert-15"></div>

